/**
 * Dosya seçicilerin (`<input type="file" accept>`) kabul listeleri — **tek kaynak**.
 *
 * <p>Bu liste bir **kolaylıktır, güvenlik sınırı değildir**: `accept` yalnız işletim sisteminin dosya
 * seçme penceresini süzer ve sürükle-bırakta istemci tarafında elenir. Gerçek kapı backend'dedir
 * (`StorageValidator.ALLOWED_EXTENSIONS`) — API'ye doğrudan istek atan bir istemci bu listeden
 * etkilenmez. Yine de listeyi doğru tutmak önemlidir: kullanıcı, seçicide göremediği bir dosyayı
 * "yüklenemiyor" sanır.
 *
 * <p><b>Neden tek dosyada:</b> bu değerler üç ayrı bileşende elle tekrarlanıyordu ve tam bu yüzden
 * ayrıştı — backend Excel'i aylardır kabul ederken üç yüzeyin seçicisi onu göstermiyordu (24.09.2026
 * kullanıcı bildirimi). Kopyalar tek tek düzeltilebilir ama bir sonraki uzantı değişikliğinde yine
 * ayrışırdı (anayasa → Reuse Mandate).
 */

/**
 * Depo doğrulayıcısının (`StorageValidator.ALLOWED_EXTENSIONS`) **birebir** istemci karşılığı — ofis
 * belgeleri + PDF + görsel + arşiv. Backend'in kabul ettiği her şeyi seçtirmek isteyen yüzeyler
 * (Etkinlik ekleri, Prensip Kararı dosyaları) bunu kullanır.
 *
 * <p>Backend listesi değişirse <b>burası da değişmelidir</b>; ikisi ayrı depolarda derlendiği için
 * derleyici bu bağı zorlayamaz.
 */
export const ATTACHMENT_ACCEPT = '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.zip,.rar'

/**
 * **Doküman** yüzeylerinin daha dar listesi: PDF · Word · <b>Excel</b> · <b>PowerPoint</b> · görsel.
 * Tutanak dokümanları, Toplantı dosyaları, Görev ve Notlarım ekleri bunu kullanır.
 *
 * <p>Daraltma bilinçlidir ve backend'den daha katıdır (spec 039 FR-011): bu bölümler okunacak
 * belgeler içindir, arşiv (`zip`/`rar`) oraya ait değildir. <b>Excel 24.09.2026'da, PowerPoint
 * (`ppt`/`pptx`) 03.11.2026'da eklendi</b> — ikisi de kullanıcı isteği; backend zaten kabul ediyordu,
 * yani kısıt yalnız istemcideydi.
 *
 * <p><b>Excel toplu yükleme (088) ile karıştırılmamalıdır:</b> orası bir dosya eki değil, **yapısal
 * bir içe aktarmadır** ve yalnız `.xlsx` kabul eder — `.xls` (HSSF) orada bilinçle reddedilir
 * (`ExcelWorkbookReader`). O ekranın kısıtı bu sabitten beslenMEZ.
 */
export const DOCUMENT_ACCEPT = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg'
